import { render, staticRenderFns } from "./ProcedurePlanUnsubscribeConfirm.vue?vue&type=template&id=1883094d&"
import script from "./ProcedurePlanUnsubscribeConfirm.vue?vue&type=script&lang=ts&"
export * from "./ProcedurePlanUnsubscribeConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports